export const dataAttributeUserId = 'data-user-id';
export const dataAttributeEmail = 'data-email';
export const dataAttributeName = 'data-name';
export const dataAttributePlaceholderName = 'data-placeholderName';
